import AssignVoucherDialog from "@saleor/components/AssignVoucherDialog";
import { DEFAULT_INITIAL_SEARCH_DATA } from "@saleor/config";
import { configurationMenuUrl } from "@saleor/configuration";
import { voucherUrl } from "@saleor/discounts/urls";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useVoucherNoShopAllSearch from "@saleor/searches/useVoucherNoShopAllSearch";
import createDialogActionHandlers from "@saleor/utils/handlers/dialogActionHandlers";
import { mapEdgesToItems } from "@saleor/utils/maps";
import React, { useState } from "react";
import { useIntl } from "react-intl";

import ProductActivationSettingDetails, {
  SettingFormData
} from "../../components/ProductActivationSettingDetails/ProductActivationSettingDetails";
import {
  useProductActivationSettingCreateDefaultMutation,
  useProductActivationSettingVoucherUpdateMutation,
  useUpdateProductActivationSettingMutation
} from "../../mutations";
import { useProductActivationSettingQuery } from "../../queries";
import {
  ProductActivationSettingDialog,
  productActivationSettingUrl,
  ProductActivationSettingUrlQueryParams
} from "../../urls";

interface ProductActivationSettingProps {
  params: ProductActivationSettingUrlQueryParams;
}
const ProductActivationSetting: React.FC<ProductActivationSettingProps> = ({
  params
}) => {
  const notify = useNotifier();
  const intl = useIntl();

  const [voucherType, setVoucherType] = useState("");

  const { data, loading, refetch } = useProductActivationSettingQuery({
    variables: {}
  });
  const id = data?.productActivationSetting
    ? data?.productActivationSetting?.id
    : "";

  const navigate = useNavigator();
  const [openModal, closeModal] = createDialogActionHandlers<
    ProductActivationSettingDialog,
    ProductActivationSettingUrlQueryParams
  >(navigate, params => productActivationSettingUrl(params), params);

  const [
    productActivationSettingUpdate,
    productActivationSettingUpdateOpts
  ] = useUpdateProductActivationSettingMutation({
    onCompleted: data => {
      if (data.productActivationSettingUpdate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Update Product Activation Setting Success"
          })
        });
      }
    }
  });

  const [defaultCreate] = useProductActivationSettingCreateDefaultMutation({
    onCompleted: data => {
      if (data.productActivationSettingCreateDefault.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Default Product Activation Setting Created"
          })
        });
        refetch();
      }
    }
  });
  const handleSubmit = async (data: SettingFormData) => {
    // eslint-disable-next-line no-console
    // console.log(data);
    const input = {
      ...data
    };
    const result = await productActivationSettingUpdate({
      variables: {
        id,
        input
      }
    });
    return result.data.productActivationSettingUpdate.errors;
  };
  const { search, loadMore, result } = useVoucherNoShopAllSearch({
    variables: DEFAULT_INITIAL_SEARCH_DATA
  });

  const [
    assignVoucher,
    assignVoucherOpts
  ] = useProductActivationSettingVoucherUpdateMutation({
    onCompleted: data => {
      if (data.productActivationSettingVoucherUpdate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Successed"
          })
        });
        closeModal();
        refetch();
      }
    }
  });

  return (
    <>
      <ProductActivationSettingDetails
        setting={id === "" ? null : data?.productActivationSetting}
        disabled={loading}
        onSubmit={handleSubmit}
        onBack={() => navigate(configurationMenuUrl)}
        saveButtonBarState={productActivationSettingUpdateOpts.status}
        onRowClick={id => () => navigate(voucherUrl(id))}
        defaultCreate={() => defaultCreate({})}
        onAddVoucher={type => () => {
          setVoucherType(type);
          openModal("assign-voucher");
        }}
      />
      <AssignVoucherDialog
        confirmButtonState={assignVoucherOpts.status}
        open={params.action === "assign-voucher"}
        hasMore={result.data?.search?.pageInfo.hasNextPage}
        onFetch={search}
        onFetchMore={loadMore}
        loading={result.loading}
        onClose={closeModal}
        onSubmit={vouchers =>
          assignVoucher({
            variables: {
              id,
              voucherType,
              voucherId: vouchers.map(voucher => voucher.id)[0]
            }
          })
        }
        vouchers={mapEdgesToItems(result?.data?.search)?.filter(
          suggestedVoucher => suggestedVoucher.id
        )}
      />
    </>
  );
};
export default ProductActivationSetting;
